export default {"src":"/login-app/[GIT_HASH]/_next/static/media/run.03cd8174.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};